import {
  useGetApiSelflearnGetTopicSummaryAndQuestions,
  useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId,
} from "@oneapp/data";
import type { FlashCardData } from "../models/FlashcardUI";
import type { GetFlashCardQuestionsProgressResponse } from "../models/FlashcardProgressResponse";

export const useGetFlashcards = (
  _examId: number,
  _gradeId: number,
  subtenantId: number,
  _subjectId: number,
  _chapterId: number,
  topicId: number,
  flashcardTypeId: number,
) => {
  const { data, isLoading } =
    useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId(
      String(topicId),
      subtenantId,
      flashcardTypeId,
      {
        request: {
          clientName: "cms",
          paramsSerializer: { indexes: null },
        },
        query: {
          select: (response) => response.data as FlashCardData,
          refetchOnMount: true,
          staleTime: 0,
        },
      },
    );

  const parsedTopicId = Number(topicId);

  const { data: progressData, isLoading: isProgressLoading } =
    useGetApiSelflearnGetTopicSummaryAndQuestions(
      {
        examId: _examId,
        gradeId: _gradeId,
        subjectId: _subjectId,
        chapterId: _chapterId,
        topicId: parsedTopicId,
      },
      {
        request: {
          clientName: "selflearn",
          paramsSerializer: { indexes: null },
        },
        query: {
          enabled: Number.isFinite(parsedTopicId),
          select: (response) =>
            response as GetFlashCardQuestionsProgressResponse,
          refetchOnMount: true,
          staleTime: 0,
        },
      },
    );

  return {
    data,
    flashcardData: data,
    flashcardProgressData: progressData,
    isLoading: isLoading || isProgressLoading,
  };
};
